import { Radio } from '@paysense-india-services/elevate-web'

import styles from './index.module.scss'

const RepaymentAmountCard = ({ data, checked, name, onChange, value }) => {
  return (
    <Radio
      checked={checked}
      className={`${styles.repaymentRadio} ew-w-100 ew-bg-primary ew-d-flex`}
      label={
        <div className='ew-d-flex ew-flex-grow-1 ew-justify-content-between ew-align-items-start ew-w-100 test'>
          <div className=''>
            <div className='ew-fw-semi-bold ew-mb-2'>{data?.title}</div>
            {data?.description ? (
              <div className='ew-typography-small ew-color-secondary ew-fw-regular'>
                {data.description}
              </div>
            ) : null}
          </div>
          {data?.subtitle ? <div className='ew-fw-semi-bold ew-ml-8'>{data.subtitle}</div> : null}
        </div>
      }
      name={name}
      onChange={onChange}
      value={value}
    />
  )
}

export default RepaymentAmountCard
